// extracted by mini-css-extract-plugin
module.exports = {"spacer":"bl_dg"};